import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "primeng/button";
import * as i2 from "@angular/common";
import * as i3 from "@ngx-translate/core";
const _c0 = a0 => ({
  "gea-button-group-selected": a0
});
function ButtonGroupV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-button", 1);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("onClick", function ButtonGroupV2Component_ng_template_1_Template_p_button_onClick_0_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeActiveItem(item_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(6, _c0, (ctx_r2._activeItem == null ? null : ctx_r2._activeItem.id) === item_r2.id));
    i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(1, 4, item_r2.label));
    i0.ɵɵproperty("size", ctx_r2.size);
  }
}
export class ButtonGroupV2Component {
  buttonItems = [];
  _activeItem = this.buttonItems[0];
  set activeItem(value) {
    if (this._activeItem === value) {
      return;
    }
    this._activeItem = value;
    this.changeActiveItem(value);
  }
  activeItemChange = new EventEmitter();
  type = 'grey';
  size = 'small';
  changeActiveItem(item) {
    this._activeItem = item;
    this.activeItemChange.emit(this._activeItem);
  }
  static ɵfac = function ButtonGroupV2Component_Factory(t) {
    return new (t || ButtonGroupV2Component)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ButtonGroupV2Component,
    selectors: [["geaui-button-group-v2"]],
    inputs: {
      buttonItems: "buttonItems",
      activeItem: "activeItem",
      type: "type",
      size: "size"
    },
    outputs: {
      activeItemChange: "activeItemChange"
    },
    decls: 2,
    vars: 4,
    consts: [["ngFor", "", 3, "ngForOf"], [3, "onClick", "size", "label"]],
    template: function ButtonGroupV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, ButtonGroupV2Component_ng_template_1_Template, 2, 8, "ng-template", 0);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("gea-button-group-container gea-button-group-type-", ctx.type, "");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.buttonItems);
      }
    },
    dependencies: [i1.Button, i2.NgForOf, i3.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ButtonGroupV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-button-group-v2',
      template: "<div class=\"gea-button-group-container gea-button-group-type-{{ type }}\">\n  <ng-template [ngForOf]=\"buttonItems\" ngFor let-item>\n    <p-button\n      [class]=\"{ 'gea-button-group-selected': _activeItem?.id === item.id }\"\n      [size]=\"size\"\n      (onClick)=\"changeActiveItem(item)\"\n      label=\"{{ item.label | translate }}\"></p-button>\n  </ng-template>\n</div>\n"
    }]
  }], null, {
    buttonItems: [{
      type: Input
    }],
    activeItem: [{
      type: Input
    }],
    activeItemChange: [{
      type: Output
    }],
    type: [{
      type: Input
    }],
    size: [{
      type: Input
    }]
  });
})();
